<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" :class="{ scrolled: isScrolled }">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png" />
      </div>
      <!-- 导航内容 -->
      <!-- <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul> -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in tabList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="tabClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
          </router-link>
          <!-- <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl> -->
        </li>
      </ul>
      <div class="login-box">
        <div class="login-txt" @click="loginClick">系统登录</div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <!-- <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul> -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in tabList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="tabClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="getPath(item)">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
        <div class="login-box">
          <div class="login-txt">系统登录</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "关于园区",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "关于园区",
          path: "/",
          children: [],
        },
        {
          name: "功能分区",
          path: "/software",
          children: [
            // {
            //   name: "智能小镇管理系统",
            //   path: "/software/smartTown",
            // },
            // {
            //   name: "大数据管理系统",
            //   path: "/software/bigData",
            // },
          ],
        },
        {
          name: "园区服务",
          path: "/service",
          children: [],
        },
        {
          name: "新闻咨询",
          path: "/newsinformation",
          children: [],
        },
        {
          name: "可持续发展",
          path: "/companyintroduction",
          children: [],
        },
        {
          name: "入驻企业",
          path: "/jobchance",
          children: [],
        },
        {
          name: "合作咨询",
          path: "/contactus",
          children: [],
        },
      ],
      tabList: [
        { name: '关于园区', path: '/home', hash: '#bigData' },
        { name: '功能分区', path: '/home', hash: '#accordion' },
        { name: '园区服务', path: '/home', hash: '#service' },
        { name: '新闻咨询', path: '/home', hash: '#news' },
        { name: '可持续发展', path: '/home', hash: '#sustainability' },
        { name: '入驻企业', path: '/home', hash: '#tenants' },
        { name: '合作咨询', path: '/home', hash: '#cooperation' },
      ],
      isScrolled: false,
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    tabClick(index, item) {
      this.navIndex = index
      const tab = this.tabList[index]
      this.$router.push({
        path: tab.path,    // /home
        hash: tab.hash     // #service
      })
    },
    getPath(item) {
      return {
        path: item.path,   // 目标页面，如 "/home"
        hash: item.hash    // 要跳到的 id，例如 "#section2"
      }
    },
    handleScroll() {
      // 判断页面是否滚动超过一定距离
      this.isScrolled = window.scrollY > 50;
    },
    // 登录
    loginClick() {
      console.log('点击登录按钮');
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
/* 顶部 */
#header {
  background: transparent;
  /* 初始状态为透明 */
  transition: background-color ease 0.6s;
}

#header.scrolled {
  background: #f4f4f4;
  /* 滚动后变为指定颜色 */
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

.container-fuild {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 65px;
  height: 65px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #f86e0b;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #f86e0b;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #f86e0b;
  text-decoration: none;
  border-bottom: 2px solid #f86e0b;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

.login-box {
  background-color: #f86e0b;
  color: #fff;
  border-radius: 20px;
  height: 40px;
  width: 90px;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue